import styled from '@emotion/styled'
import { Input, Modal, Segment } from 'semantic-ui-react'

export const PhotoFieldsStyle = styled.div`
  &&&&& {
    margin: 0 0 10px 0;
  }
`

export const PhotoFileInputStyle = styled.input`
  &&&&& {
    border: none;
    padding-left: 0;
    margin-left: 0;
    max-width: 100px;
  }
`

export const InputWithActionStyle = styled(Input)`
  &&& {
    input {
      border: 1px solid rgba(34, 36, 38, 0.15);
      margin-left: 3px;
      border-left-color: rgba(34, 36, 38, 0.15) !important;
      border-radius: 0.28571429rem !important;
    }

    input[type='number'] {
      width: 70px !important;
    }
  }
`

export const ArrayFieldLabelStyle = styled.label`
  &&&&& {
    margin-top: 15px;
    margin-bottom: 15px;
    display: inline-block;
    font-weight: 700;
  }
`

export const ProductsSegmentStyle = styled(Segment)`
  &&&& {
    padding-top: 25px;

    form {
      max-width: 1500px;

      .product-form-label {
        margin-right: 3%;
      }
      label {
        vertical-align: middle;
      }
      input:not(.full-width) {
        width: 45%;
      }
      input.full-width {
        width: 85%;
      }
      input:read-only {
        border: none;
      }
      textarea {
        max-width: 83%;
      }
      select {
        height: 38px;
      }
    }

    form#create-product-form {
      i.icon {
        padding-top: 3px;
      }
    }

    @media (max-width: 640px) {
      form {
        .product-form-label {
          width: 100%;
        }
        input {
          width: 100%;
        }
        textarea {
          max-width: 100%;
        }
      }
    }
  }

  .product-modal &&& {
    padding-top: 0;

    form {
      max-width: 1390px;
    }
  }
`

export const ProductModalStyle = styled(Modal)`
  &&& {
    width: 98%;
    height: 96%;
    margin: 0 !important;

    .scrolling.content {
      max-height: 100%;
      padding: 10px 10px 3px;
    }
  }
`

export const ProductTitleStyle = styled.h2`
  &&&&& {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0;
    margin-right: 30px;
    padding-bottom: 5px;
  }
`
export const StyledProductImagesHolder = styled('div')`
  &&&&& {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
`
export const StyledProductImage = styled('div')`
  &&&&& {
    display: flex;
    justify-content: space-between;
    width: 150px;
    margin-bottom: 10px;
  }
`
